module.exports = __webpack_public_path__ + "static/media/elegibilidade.c805db38.svg";